module.exports = __webpack_public_path__ + "img/QOOKER_Box17.fd585ad2.jpg";